import React from 'react';

interface TextareaProps {
  label: string;
  name: string;
  id: string;
  placeholder?: string;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  error?: string;
  className?: string;
}

const Textarea: React.FC<TextareaProps> = ({
  label,
  name,
  id,
  placeholder,
  value,
  onChange,
  error,
  className = '',
}) => {
  return (
    <label htmlFor={id} className="label group/label">
      <p className="label-text">{label}</p>
      <textarea
        className={`input peer h-full min-h-[100px] ${className}`}
        name={name}
        id={id}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
      />
      {error && (
        <p className="input-error">
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8 0C12.4183 0 16 3.58172 16 8C16 10.1217 15.1575 12.1569 13.6572 13.6572C12.1569 15.1575 10.1217 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0ZM8.19043 11.0195C7.86419 10.9542 7.52644 11.0559 7.29004 11.29C7.10286 11.4788 6.99846 11.7342 7 12C6.99846 12.2658 7.10286 12.5212 7.29004 12.71C7.38724 12.7983 7.49893 12.8693 7.62012 12.9199C7.86212 13.0269 8.13788 13.0269 8.37988 12.9199C8.50106 12.8693 8.61276 12.7983 8.70996 12.71C8.89715 12.5212 9.00154 12.2658 9 12C8.99632 11.7352 8.89269 11.4817 8.70996 11.29C8.66244 11.247 8.61195 11.2068 8.55957 11.1699C8.50392 11.1322 8.44348 11.1019 8.37988 11.0801C8.32046 11.0497 8.25652 11.0288 8.19043 11.0195ZM8 3C7.44772 3 7 3.33579 7 3.75V8.25C7 8.66421 7.44772 9 8 9C8.55229 9 9 8.66421 9 8.25V3.75C9 3.33579 8.55229 3 8 3Z"
              fill="#DF064F"
            />
          </svg>
          {error}
        </p>
      )}
    </label>
  );
};

export default Textarea;